import React from "react";
import "./styles/theme.css";
import "./styles/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import AppRoutes from "./AppRoutes";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import "./styles/global.css";

import "./services/WebSocketClient";

function App() {
  return (
    <div className="app-wrapper d-flex flex-column min-vh-100">
      <main className="flex-grow-1">
        <AppRoutes />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default App;
